import { useEffect, useRef, useState } from "react";
import "./CardIntegratedPosition.css";

export default function CardIntegratedPosition({
    icon,
    title,
    value,
    variation,
    description,
    buttonText = "Ver detalhes",
    onClick
}) {

    return (
        <div className="product-card">
            <div className="product-card__header">
                <img
                    src={icon}
                    alt={title}
                    className="product-card__icon"
                />
                <span
                    className="product-card__title"
                >
                    {title}
                </span>
            </div>
            <h2 className="product-card__value">
                {value}
            </h2>
            <span className="product-card__variation">
                {variation}
            </span>
            <p className="product-card__description">
                {description}
            </p>
            <button
                className="product-card__button"
                onClick={onClick}>
                {buttonText}
            </button>
        </div>
    );
}